<template>
  <div class="events-search-bar py-5">
    <student-search-bar
      ref="formSearch"
      v-if="hasValidRole(userRole, Role.Student)"
    ></student-search-bar>
    <teacher-search-bar
      ref="formSearch"
      v-else-if="hasValidRole(userRole, Role.Teacher)"
    ></teacher-search-bar>
    <counselor-search-bar
      ref="formSearch"
      v-else-if="hasValidRole(userRole, Role.Counselor)"
    ></counselor-search-bar>
    <family-search-bar
      ref="formSearch"
      v-else-if="hasValidRole(userRole, Role.Family)"
    ></family-search-bar>
    <admin-search-bar ref="formSearch" v-else></admin-search-bar>
  </div>
</template>

<script>
import AdminSearchBar from "./Admin.vue";
import StudentSearchBar from "./Student.vue";
import TeacherSearchBar from "./Teacher.vue";
import CounselorSearchBar from "./Counselor.vue";
import FamilySearchBar from "./Family.vue";
import { mapGetters } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";

export default {
  components: {
    AdminSearchBar,
    StudentSearchBar,
    TeacherSearchBar,
    CounselorSearchBar,
    FamilySearchBar
  },
  data() {
    return {
      Role,
      hasValidRole
    };
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    })
  },
  methods: {
    getQueryParams() {
      return this.$refs.formSearch.getQueryParams();
    }
  }
};
</script>
